const labels = {
  cash: 'Cash on Delivery',
  sslcommerz: 'SSLCommerz',
  bkash: 'bKash',
  nagad: 'Nagad',
  card: 'Card Payment'
};

export const getPaymentMethodLabel = (method) => {
  const normalized = String(method || '').trim().toLowerCase();

  if (!normalized) return 'N/A';
  if (labels[normalized]) return labels[normalized];
  if (normalized.includes('ssl')) return 'SSLCommerz';
  if (normalized.includes('cash')) return 'Cash on Delivery';

  return normalized
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const isCashOnDelivery = (method) => String(method || '').trim().toLowerCase() === 'cash';

